module.exports = __webpack_public_path__ + "static/media/bo.607a7e95.svg";